import {
    getExtendedTinList,
    providerKey,
} from '@src/apps/psms/ViewTaxIdDetails/ViewTaxIdDetails.service';
import {
    PSMS_TAXID_EXTENDED_TIN_REQUEST,
    PSMS_TAXID_HEALTH_SYSTEM_REQUEST,
} from '@src/middleware/actions/actionTypes';
import {
    fetchExtendedTinListFailure,
    fetchExtendedTinListLoading,
    fetchExtendedTinListSuccess,
    fetchHealthSystemDataFailure,
    fetchHealthSystemDataLoading,
    fetchHealthSystemDataSuccess,
} from '@src/middleware/actions/psms/viewTaxIdActions';
import { call, put, takeLatest } from 'redux-saga/effects';

export function* fetchHealthSystemDataSaga() {
    try {
        yield put(fetchHealthSystemDataLoading(true));
        const response = yield call(providerKey);
        if (response) {
            yield put(fetchHealthSystemDataSuccess(response));
        } else {
            yield put(fetchHealthSystemDataFailure('Failed to fetch health system data'));
        }
    } catch (error) {
        yield put(fetchHealthSystemDataFailure(error));
    } finally {
        yield put(fetchHealthSystemDataLoading(false));
    }
}

export function* fetchExtendedTinListSaga() {
    try {
        yield put(fetchExtendedTinListLoading(true));
        const response = yield call(getExtendedTinList, null);
        if (response?.Data) {
            yield put(fetchExtendedTinListSuccess(response));
        } else {
            yield put(fetchExtendedTinListFailure('Failed to fetch extended TIN list'));
        }
    } catch (error) {
        yield put(fetchExtendedTinListFailure(error));
    } finally {
        yield put(fetchExtendedTinListLoading(false));
    }
}

export default function* viewTaxIdSaga() {
    yield takeLatest(PSMS_TAXID_HEALTH_SYSTEM_REQUEST, fetchHealthSystemDataSaga);
    yield takeLatest(PSMS_TAXID_EXTENDED_TIN_REQUEST, fetchExtendedTinListSaga);
}
